/** Map `getSellerProducts` items to table / drawer shapes used by the seller UI. */

export function formatSellerProductListPrice(price) {
  const n = Number(price);
  if (Number.isNaN(n)) return "—";
  return `$${n.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
}

export function sellerProductStockChipStatus(p) {
  const qty = Number(p.quantityInStock) || 0;
  const alert = Number(p.lowStockAlert);
  if (!p.isInStock || qty === 0) return "sold-out";
  if (Number.isFinite(alert) && alert > 0 && qty <= alert) return "low-stock";
  return "in-stock";
}

/** Category line for table / filters: primary `categories[].name`, not `alias`. */
export function sellerProductCategoriesLabel(p) {
  if (!Array.isArray(p.categories) || !p.categories.length) return "";
  const names = p.categories.map((c) => c?.name).filter(Boolean);
  return names.length ? names.join(", ") : "";
}

export function sellerProductCategoryLabel(p) {
  const fromCategories = sellerProductCategoriesLabel(p);
  if (fromCategories) return fromCategories;
  if (Array.isArray(p.tags) && p.tags.length) return String(p.tags[0]);
  if (typeof p.tags === "string" && p.tags.trim()) {
    return p.tags.split(",")[0].trim();
  }
  return "—";
}

export function mapSellerProductToListRow(p) {
  return {
    id: p._id,
    name: p.name || "—",
    sku: p.reference || "—",
    category: sellerProductCategoryLabel(p),
    price: formatSellerProductListPrice(p.price),
    stock: Number(p.quantityInStock) || 0,
    status: sellerProductStockChipStatus(p),
    image: Array.isArray(p.images) ? p.images[0] : undefined,
    raw: p,
  };
}

export function mapSellerProductToDrawerDetail(p) {
  const row = mapSellerProductToListRow(p);
  const images = Array.isArray(p.images) ? p.images.filter(Boolean) : [];
  const categoryDetail =
    sellerProductCategoriesLabel(p) || row.category;
  return {
    ...row,
    categoryDetail,
    description: p.description || "—",
    weight: p.weight != null ? String(p.weight) : "—",
    totalOrders: "—",
    images,
    /** Raw product lifecycle status from API (e.g. CREATED, APPROVED) — not stock chip. */
    productListingStatus: p.status ?? null,
  };
}
